module.exports = __webpack_public_path__ + "static/media/icon_grid_2.c6b23f6e.svg";